<template>
  <div>
    <div class="exercise-item text-left" v-if="question.typeQuestion == 'radio' || question.typeQuestion == 'multichoice'">
      <div class="exercise-body" v-if="labelColors && question.typeQuestion == 'radio'">
        <div class="text-left">
          <div class="form-group" v-for="(answer, index) in question.answers" :key="answer.guid">
            <div class="radioBoxes" :class="{'ellipsis': showEllipsis}" @click="showEllipsis = !showEllipsis">
                <!--{{answer}}-->
                <div style="display: inline-block; width: 100px; text-align: right;">
                  <div style="color: #b1b1b1;">
                    (<span v-if="results.reduce((a, c) => a + c, 0) != 0">{{Math.round(results[index]/results.reduce((a, c) => a + c, 0)*100*100)/100}}</span><span v-else>0</span>%  = {{results[index]}} / {{Math.round(100 *results.reduce((a, c) => a + c, 0))/100}} )
                  </div>
                </div>
                <div v-if="answer.correct" style="display: inline-block; background-color: #4aa362; border-radius: 5px;" :style="{width: (3*Math.round(results[index]/results.reduce((a, c) => a + c, 0)*100*100)/100 + 3) + 'px' }">
                  <span style="color:#4aa362">|</span>
                </div>
                <div v-else style="display: inline-block; background-color: #da7162; border-radius: 5px;" :style="{width: (3*Math.round(results[index]/results.reduce((a, c) => a + c, 0)*100*100)/100 + 3) + 'px' }">
                  <span style="color: #da7162;">|</span>
                </div>
                <!-- <input class="awesomeRadioButton" :id="index" :value="answer.guid" v-model="answer.selectedAnswer" type="radio"> -->
                <div v-html="$options.filters.pickTranslation(answer.text)" style="display: inline-block;"></div>
            </div>
          </div>
        </div>
      </div>
        <!-- {{question}} <br>
        {{results}} <br>
        {{ resultLabels}} <br>
        {{labelColors}} -->
    <!-- <beginExercise :CelotnaNaloga="exerciseVersion"></beginExercise>
          <template v-for="uprasanje in exerciseVersion.questions">
            <numeric v-if="uprasanje.type.toLowerCase() == 'numerical'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings"></numeric>
            <radio v-if="uprasanje.type.toLowerCase() == 'radio'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings"></radio>
            <essay v-if="uprasanje.type.toLowerCase() == 'essay'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings"></essay>
            <multichoice v-if="uprasanje.type.toLowerCase() == 'multichoice'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings"></multichoice>
            <slider v-if="uprasanje.type.toLowerCase() == 'slider'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings"></slider>
          </template> -->
    </div>
    <!-- <div class="exercise-item text-left" v-if="question.typeQuestion == 'numerical'">
  <div class="row">
    <div class="col-sm-12">
      <bar style="height: 20em" class="" :height="125" :chartData="{labels: createHistogramGroups(question.rawResponses)[0], datasets: [{label: $t('pages.adminpanel.ratingStatistics.numberOfStudents'), backgroundColor: '#2872ca', data: createHistogramGroups(question.rawResponses)[1]}]}" :options="{maintainAspectRatio: false, responsive: true, scales: {xAxes: [{stacked: true, barPercentage: '1',  categoryPercentage: '0.9'}], yAxes: [{stacked: true}]}}"></bar>
    </div>
  </div>
  </div> -->
  </div>
</template>

<script>
import Numeric from '@/components/exercises/types/Numeric.vue'
import Radio from '@/components/exercises/types/Radio.vue'
import Multichoice from '@/components/exercises/types/Multichoice.vue'
import Essay from '@/components/exercises/types/Essay.vue'
import BeginExercise from '@/components/exercises/ExerciseTitle.vue'
import Slider from '@/components/exercises/types/Slider.vue'
import Bar from '@/charts/Bar.js'
let crypto = require('crypto')
export default {
  data () {
    return {
      showEllipsis: true
    }
  },
  props: ['question', 'results', 'resultLabels', 'labelColors'],
  methods: {
    createHistogramGroups (answers) {
      let numberOfColumns = 9
      let min = Math.min.apply(null, answers)
      let max = Math.max.apply(null, answers)
      if (isNaN(min)) {
        min = 0
      }
      if (isNaN(max)) {
        max = 0
      }
      if (max === min) {
        min -= 1
        max += 1
      }
      let step = (max - min) / numberOfColumns
      let columnNames = []
      let columnValues = []
      for (let i = 0; i < numberOfColumns; i++) {
        columnNames.push((Math.round((min + i * step) * 100) / 100) + '-' + (Math.round((min + (i + 1) * step) * 100) / 100))
        columnValues.push(0)
      }
      for (let i = 0; i < answers.length; i++) {
        columnValues[Math.min(Math.floor((answers[i] - min) / step), columnValues.length - 1)]++
      }
      return [columnNames, columnValues]
    },
    getUniqueKey () { // async?
      let generated = crypto.randomBytes(20).toString('hex')
      while (window.jQuery(this.nameOfQuestion + generated) == null) {
        generated = crypto.randomBytes(20).toString('hex')
      }
      return generated
    }
  },
  watch: {
  },
  components: {
    'numeric': Numeric,
    'radio': Radio,
    'multichoice': Multichoice,
    'essay': Essay,
    'beginExercise': BeginExercise,
    'slider': Slider,
    bar: Bar
  },
  mounted () {
    // this.evalProps()
    this.$nextTick(function () {
      window.MathJax.Hub.Queue(
        ['Typeset', window.MathJax.Hub]
      )
    /* var math = window.MathJax.Hub.getAllJax('exerciseStatList')[0]
    window.MathJax.Hub.Queue(['Text', math]) */
    })
    this.showEllipsis = true
  }
}
</script>

<style scoped>
.fa-check {
  color: #00a65a;
}
.fa-times {
  color: #f56954;
}
.exercise-body, .exercise-item {
  padding-left: 1ex;
}
.small-button{
  padding-left: 1em !important;
  padding-right: 1em !important;
}
.exercise-footer button {
  padding-left: 2em;
  padding-right: 2em;
  margin: 1ex;
}
.exercise-item .time {
  float: right;
}
.exercise-header {
  margin-bottom: 1em;
}

.enum {
  counter-reset: item;
}

.enum > li {
  display: table;
  counter-increment: item;
}

.enum > li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
}

.enum_alph {
  counter-reset: list;
}
.enum_alph > li {
  list-style: none;
}
.enum_alph > li:before {
  content: counter(list, lower-alpha) ") ";
  counter-increment: list;
}

.ellipsis {
  height: 2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// ExerciseResultsPreview.vue?a172b984